module.exports = __webpack_public_path__ + "static/media/bayst-arbeit-und-soziales.d99d6d95.jpg";